<template>
  <BoxCard>
    <template #header>
      <div class="flex justify-between">
        <p>Applications</p>
      </div>
    </template>
    <template #content>
      <span
        v-if="loading"
        class="
          h-36
          ease-in
          duration-200
          inset-0
          w-full
          flex
          items-center
          justify-center
          animate-spin
          z-10'
        "
        aria-hidden="true"
      >
        <svg class="bg-white h-5 w-5 text-vice-teal-500" fill="none" viewBox="0 0 14 14">
          <circle cx="7" cy="7" r="6" stroke-dasharray="30" stroke="#24b8a7" stroke-width="2" />
        </svg>
      </span>
      <ul v-if="pendingApplicationsList.length" role="list" class="divide-y divide-gray-100">
        <li
          v-for="(application, index) in pendingApplicationsList"
          :key="application.id"
          class="flex relative justify-between gap-x-2 py-4"
          :class="{
            'pt-0': index == 0,
            'pb-0': index == pendingApplicationsList.length - 1,
          }"
        >
          <div class="flex gap-x-4">
            <ViceAvatar
              :name="application.user.name"
              :image="application.user.profile_photo_url"
              class="w-12 h-12 text-lg min-w-12 bg-gray-200"
            />
            <div class="min-w-0 flex-auto">
              <p class="text-sm font-semibold leading-6 text-gray-900">
                {{ application.user.name }}
              </p>

              <ViceBadge v-if="application.user_type == 'participant'" indigo small icon="UserIcon">
                {{ application.user_type }}
              </ViceBadge>

              <ViceBadge v-else yellow small icon="EyeIcon">
                {{ application.user_type }}
              </ViceBadge>
            </div>
          </div>
          <div class="flex relative sm:items-center gap-1">
            <ViceButton
              circle
              small
              green
              icon="CheckIcon"
              btnDescription="Accept"
              @click="acceptApplication(application.id)"
            />
            <ViceButton
              circle
              small
              red
              icon="XIcon"
              btnDescription="Decline"
              @click="declineApplication(application.id)"
            />
          </div>
        </li>
      </ul>
      <div v-else-if="!loading" class="text-xs text-gray-500 flex items-center justify-center">
        No pending applications
      </div>
    </template>
  </BoxCard>
</template>

<script>
import { ref, onMounted, computed } from 'vue';

// import axios from 'axios';
// import { Inertia } from '@inertiajs/inertia';
import { usePage } from '@inertiajs/inertia-vue3';
import ViceAvatar from '@/Components/Avatars/ViceAvatar.vue';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import ViceBadge from '@/Components/Badges/ViceBadge.vue';
import BoxCard from '@/Components/Cards/BoxCard.vue';

export default {
  name: 'Application',
  components: {
    BoxCard,
    ViceAvatar,
    ViceButton,
    ViceBadge,
  },
  setup() {
    const loading = ref(false);
    const applicationsList = ref([]);
    onMounted(() => {
      const pageProps = usePage().props.value;
      fetchSessionApplications(pageProps.session.unique_id);
    });

    const pendingApplicationsList = computed(() =>
      applicationsList.value.filter(
        (application) => application.accepted_at === null && application.declined_at === null,
      ),
    );

    const fetchSessionApplications = (sessionId) => {
      loading.value = true;
      // Todo: Implement API call to fetch applications for a session
      console.log(sessionId);
      axios.get(route('session.getOpenApplications', sessionId)).then((response) => {
        console.log(response.data.applications);
        applicationsList.value = response.data.applications;
        loading.value = false;
      });
    };

    const acceptApplication = (applicationId) => {
      axios
        .post(route('session.acceptApplication'), {
          application_id: applicationId,
          session_id: usePage().props.value.session.id,
        })
        .then(() => {
          applicationsList.value = applicationsList.value.filter(
            (application) => application.id !== applicationId,
          );
        })
        .catch((error) => {
          console.error(error);
        });
    };

    const declineApplication = (applicationId) => {
      axios
        .post(route('session.declineApplication'), {
          application_id: applicationId,
          session_id: usePage().props.value.session.id,
        })
        .then(() => {
          applicationsList.value = applicationsList.value.filter(
            (application) => application.id !== applicationId,
          );
        })
        .catch((error) => {
          console.error(error);
        });
    };

    return {
      pendingApplicationsList,
      userType,
      loading,
      acceptApplication,
      declineApplication,
    };
  },
};
</script>

<style scoped></style>
